import { AccountOption } from "@/services/bedrock";

export const GOOGLE_LOCATION_WARNING = {
  title: "Reviews aren't available for this location",
  description:
    "Google treats this listing as a duplicate. Connect an account that has the primary listing, or choose a different location.",
};

export function locationResourceId(name?: string | null): string {
  return name?.toString().split("/").filter(Boolean).pop() || "";
}

export function findCanonicalLocation(
  options: AccountOption[],
  duplicateOf?: string | null
): AccountOption | undefined {
  const duplicateId = locationResourceId(duplicateOf);
  if (!duplicateId) return undefined;

  return options.find(option => !option.isDuplicate && locationResourceId(option.id) === duplicateId);
}

export function googleDuplicateWarning(
  option: AccountOption,
  options: AccountOption[]
): { title: string; description: string } {
  const canonical = findCanonicalLocation(options, option.duplicateOf);
  if (canonical) {
    return {
      title: GOOGLE_LOCATION_WARNING.title,
      description: `Google treats this listing as a copy of "${canonical.name}", which is already on this connection. Select that location instead.`,
    };
  }

  return GOOGLE_LOCATION_WARNING;
}
